'use strict'
import header from './header'
import studentHeader from './studentHeader'

import footer from './footer'

import sort from './../indentify/sortPage'

export default { header,sort,studentHeader,footer}



// WEBPACK FOOTER //
// ./src/components/index.js